<template>
  <base-section id="calculation" space="5">
    <v-container fluid>
      <v-card outlined>
        <v-tabs
          v-model="tab"
          background-color="secondary"
          centered
          dark
          icons-and-text
          dense
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-1" v-if="login_user === 'pegadaian.pusat'">
            DASHBOARD
            <v-icon>mdi-chart-arc</v-icon>
          </v-tab>
          <v-tab href="#tab-2">
            KALKULATOR
            <v-icon>mdi-calculator</v-icon>
          </v-tab>
          <v-tab href="#tab-3">
            E-POLIS
            <v-icon>mdi-file-document</v-icon>
          </v-tab>
          <v-tab
            href="#tab-4"
            @click="GetTotalClaim"
            v-if="login_user === 'pegadaian.pusat'"
          >
            KLAIM
            <v-icon>mdi-shield-check</v-icon>
          </v-tab>
          <!-- <v-tab href="#tab-4">
            SUBROGASI
            <v-icon>mdi-cash-register</v-icon> -->
          <!-- </v-tab> -->
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <v-card-title class="body-2 font-weight-bold">
              DASHBOARD PEGADAIAN
            </v-card-title>
            <div></div>
            <v-btn
              v-for="row in items.filter"
              :key="row.id"
              @click="FilterData(row.id)"
              :class="row.id === form.filter ? 'primary' : ''"
              depressed
              >{{ row.id }}
            </v-btn>
            <div
              v-if="form.filter === 'PEMBIAYAAN'"
              class="ml-2 mt-2 fourth--text"
            >
              Perhitungan Ratio Klaim 75% dari Total Kontribusi
            </div>
            <div v-else class="ml-2 mt-2 primary--text">
              Perhitungan Ratio Klaim 100% dari Total Kontribusi
            </div>
            <div></div>
            <v-progress-linear
              indeterminate
              color="primary"
              v-if="loading.kanwil"
            ></v-progress-linear>
            <v-text-field
              v-model="search.product"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="mx-2"
            ></v-text-field>
            <v-data-table
              :headers="headers_product"
              :search="search.product"
              :items="item.product"
              dense
              class="elevation-0"
              :loading="loading.product"
              loading-text="Loading details..."
            >
              <template v-slot:item.contribution="{ item }">
                {{ $functions.FormatNumber(item.contribution) }}
              </template>
              <template v-slot:item.total_claim="{ item }">
                {{ $functions.FormatNumber(item.total_claim) }}
              </template>
              <template v-slot:item.percentage="{ item }">
                <span
                  :style="{
                    color:
                      CalculatePercentage(
                        item.total_claim,
                        item.contribution,
                        item.total_subrogation
                      ) > 75
                        ? 'red'
                        : 'green'
                  }"
                >
                  {{
                    CalculatePercentage(
                      item.total_claim,
                      item.contribution,
                      item.total_subrogation
                    )
                  }}
                  %
                </span>
              </template>
              <template v-slot:item.total_subrogation="{ item }">
                {{ $functions.FormatNumber(item.total_subrogation) }}
              </template>

              <!-- Tambahkan subtotal di footer -->
              <template v-slot:body.append>
                <tr>
                  <td class="text-right font-weight-bold">Subtotal</td>
                  <td></td>
                  <!-- Kosong untuk "Produk" -->
                  <td class="text-right font-weight-bold">
                    {{ $functions.FormatNumber(totalContribution) }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ $functions.FormatNumber(totalClaim) }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ $functions.FormatNumber(totalSubrogation) }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{
                      CalculatePercentage(
                        totalClaim,
                        totalContribution,
                        totalSubrogation
                      )
                    }}%
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-text-field
              v-model="search.kanwil"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="mx-2"
            ></v-text-field>
            <v-data-table
              :headers="headers_kanwil"
              :items="item.policybykanwil"
              :search="search.kanwil"
              @input="Check($event)"
              item-key="policy_ano"
              class="elevation-1"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right'
              }"
              dense
              :loading="loading.list"
              loading-text="Loading... Please wait"
              :single-expand="true"
              :show-expand="false"
              :expanded.sync="expanded"
              :items-per-page="10"
              @click:row="HandleRowClick"
            >
              <template v-slot:item="props">
                <tr
                  @click="HandleRowClick(props.item)"
                  :class="{
                    'expanded-row': isExpanded(props.item.id),
                    'custom-bg': isExpanded(props.item.id)
                  }"
                >
                  <td
                    v-for="header in props.headers"
                    :key="header.text"
                    :style="{ textAlign: header.align || 'left' }"
                  >
                    <template v-if="header.value === 'contribution'">
                      {{ $functions.FormatNumber(props.item[header.value]) }}
                    </template>
                    <template v-else-if="header.value === 'total_claim'">
                      {{ $functions.FormatNumber(props.item[header.value]) }}
                    </template>
                    <template v-else-if="header.value === 'percentage'">
                      <span
                        :style="{
                          color:
                            CalculatePercentage(
                              props.item.total_claim,
                              props.item.contribution,
                              props.item.total_subrogation
                            ) > 75
                              ? 'red'
                              : 'green'
                        }"
                      >
                        {{
                          CalculatePercentage(
                            props.item.total_claim,
                            props.item.contribution,
                            props.item.total_subrogation
                          )
                        }}
                        %
                      </span>
                    </template>
                    <template v-else-if="header.value === 'total_subrogation'">
                      {{ $functions.FormatNumber(props.item[header.value]) }}
                    </template>
                    <template v-else>
                      {{ props.item[header.value] }}
                    </template>
                  </td>
                </tr>
                <!-- Expanded content for Kanwil -->
                <tr v-if="isExpanded(props.item.id)">
                  <td :colspan="headers_kanwil.length" class="custom-bg">
                    <v-card flat>
                      <v-card-title class="text-detail"
                        >AREA PADA {{ props.item.description }}</v-card-title
                      >
                      <v-progress-linear
                        indeterminate
                        color="primary"
                        v-if="loading.area"
                      ></v-progress-linear>
                      <v-text-field
                        v-model="search.area"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        class="mx-2"
                      ></v-text-field>
                      <v-data-table
                        :headers="headers_area"
                        :search="search.area"
                        :items="item.policybyarea"
                        dense
                        class="elevation-0"
                        :loading="loading.detail"
                        loading-text="Loading details..."
                        :single-expand="true"
                        :show-expand="false"
                        :expanded.sync="expandedArea"
                        @click:row="HandleAreaRowClick"
                      >
                        <template v-slot:item="{ item: areaItem }">
                          <tr
                            @click="HandleAreaRowClick(areaItem)"
                            :class="{
                              'expanded-row-area': isAreaExpanded(areaItem.id),
                              'custom-bg-area': isAreaExpanded(areaItem.id)
                            }"
                          >
                            <td
                              v-for="header in headers_area"
                              :key="header.text"
                              :style="{ textAlign: header.align || 'left' }"
                            >
                              <template v-if="header.value === 'contribution'">
                                {{
                                  $functions.FormatNumber(
                                    areaItem[header.value]
                                  )
                                }}
                              </template>
                              <template
                                v-else-if="header.value === 'total_claim'"
                              >
                                {{
                                  $functions.FormatNumber(
                                    areaItem[header.value]
                                  )
                                }}
                              </template>
                              <template
                                v-else-if="header.value === 'percentage'"
                              >
                                <span
                                  :style="{
                                    color:
                                      CalculatePercentage(
                                        areaItem.total_claim,
                                        areaItem.contribution,
                                        areaItem.total_subrogation
                                      ) > 75
                                        ? 'red'
                                        : 'green'
                                  }"
                                >
                                  {{
                                    CalculatePercentage(
                                      areaItem.total_claim,
                                      areaItem.contribution,
                                      areaItem.total_subrogation
                                    )
                                  }}
                                  %
                                </span>
                              </template>
                              <template
                                v-else-if="header.value === 'total_subrogation'"
                              >
                                {{
                                  $functions.FormatNumber(
                                    areaItem[header.value]
                                  )
                                }}
                              </template>
                              <template v-else>
                                {{ areaItem[header.value] }}
                              </template>
                            </td>
                          </tr>
                          <!-- Expanded content for Area (Outlet) -->
                          <tr v-if="isAreaExpanded(areaItem.id)">
                            <td
                              :colspan="headers_area.length"
                              class="custom-bg-area"
                            >
                              <v-card flat>
                                <v-card-title class="text-detail-outlet"
                                  >OUTLET PADA
                                  {{ areaItem.description }}</v-card-title
                                >
                                <v-progress-linear
                                  indeterminate
                                  color="orange"
                                  v-if="loading.outlet"
                                ></v-progress-linear>
                                <v-text-field
                                  v-model="search.outlet"
                                  append-icon="mdi-magnify"
                                  label="Search"
                                  single-line
                                  hide-details
                                  class="mx-2"
                                ></v-text-field>
                                <v-data-table
                                  :headers="headers_outlet"
                                  :search="search.outlet"
                                  :items="item.policybyoutlet"
                                  dense
                                  class="elevation-0"
                                  hide-default-footer
                                >
                                  <template v-slot:item.contribution="{ item }">
                                    {{
                                      $functions.FormatNumber(item.contribution)
                                    }}
                                  </template>
                                  <template v-slot:item.total_claim="{ item }">
                                    {{
                                      $functions.FormatNumber(item.total_claim)
                                    }}
                                  </template>
                                  <template v-slot:item.percentage="{ item }">
                                    <span
                                      :style="{
                                        color:
                                          CalculatePercentage(
                                            item.total_claim,
                                            item.contribution,
                                            item.total_subrogation
                                          ) > 75
                                            ? 'red'
                                            : 'green'
                                      }"
                                    >
                                      {{
                                        CalculatePercentage(
                                          item.total_claim,
                                          item.contribution,
                                          item.total_subrogation
                                        )
                                      }}
                                      %
                                    </span>
                                  </template>
                                  <template
                                    v-slot:item.total_subrogation="{ item }"
                                  >
                                    {{
                                      $functions.FormatNumber(
                                        item.total_subrogation
                                      )
                                    }}
                                  </template>
                                </v-data-table>
                              </v-card>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-card-title class="body-2 font-weight-bold">
              TAKAFUL KENDARAAN BERMOTOR - KALKULATOR
            </v-card-title>
            <v-layout>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-money="format"
                    v-model.lazy="form.tsi"
                    ref="tsi"
                    label="Harga Kendaraan  *"
                    class="mx-2"
                    prepend-inner-icon="mdi-cash"
                    required="required"
                    :readonly="form.calculate === true ? true : false"
                    :filled="form.calculate === true ? true : false"
                    @input="GetData('tsi')"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.wilayah"
                    label="Nomor Polisi *"
                    class="mx-2"
                    prepend-inner-icon="mdi-menu-down"
                    :prefix="form.plat"
                    required="required"
                    :readonly="true"
                    @click="GetData('platnomor')"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.year"
                    label="Tahun Kendaraan *"
                    class="mx-2"
                    prepend-inner-icon="mdi-calendar-month"
                    :suffix="form.age"
                    required="required"
                    @change="GetData('age')"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="form.produk"
                    label="Produk *"
                    class="mx-2"
                    prepend-inner-icon="mdi-clipboard-list-outline"
                    :items="item.produk"
                    item-text="desc"
                    item-value="id"
                    persistent-hint
                    return-object
                    single-line
                    @change="GetData('produk')"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="form.tipe"
                    label="Jenis Kendaraan *"
                    class="mx-2"
                    prepend-inner-icon="mdi-view-list"
                    :items="item.tipe"
                    item-text="desc"
                    item-value="id"
                    persistent-hint
                    return-object
                    single-line
                    @change="GetData('tipe')"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="form.period"
                    label="Periode (Bulan) *"
                    class="mx-2"
                    prepend-inner-icon="mdi-calendar"
                    required="required"
                    @change="GetData('period')"
                  />
                </v-col>
              </v-row>
            </v-layout>
            <template v-if="form.calculate" class="text-center">
              <div class="mx-2">
                <strong>SILAHKAN PILIH COVERAGE *</strong>
                <table
                  class="table table-responsive table-newcustom"
                  width="85%"
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th width="5%">%</th>
                      <th width="10%">RATE</th>
                      <th width="15%">COVERAGE *</th>
                      <th width="12%">TSI</th>
                      <th>KONTRIBUSI</th>
                      <th width="5%">LOADING</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="n in form.number" :key="n">
                      <td>TAHUN - {{ n }}</td>
                      <td>
                        <input
                          type="text"
                          :value="form.depre[n]"
                          class="form-text-readonly text-right"
                          size="5"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          :value="form.rate[n]"
                          class="form-text-readonly text-right"
                          size="10"
                        />
                      </td>
                      <td>
                        <select
                          v-model="form.coverage[n]"
                          class="form-select form-text-combo"
                          @change="Coverage(n)"
                        >
                          <option value="">Please Select</option>
                          <option
                            v-for="row in item.coverage"
                            :value="row"
                            :key="row"
                            >{{ row }}</option
                          >
                        </select>
                      </td>
                      <td>
                        <input
                          type="text"
                          :value="form.detailtsi[n]"
                          v-money="format"
                          class="form-text-numeric text-right"
                          :readonly="true"
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          :value="form.contribution[n]"
                          class="form-text-readonly text-right"
                          size="35"
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          :value="form.loading[n]"
                          class="form-text-readonly text-right"
                          size="15"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-right font-weight-black">
                        TOTAL KONTRIBUSI
                      </td>
                      <td>
                        <input
                          type="text"
                          :value="form.totalcontribution"
                          class="form-text-readonly text-right"
                          size="35"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-right font-weight-black">
                        LOADING
                      </td>
                      <td>
                        <input
                          type="text"
                          :value="form.totalloading"
                          class="form-text-readonly text-right"
                          size="35"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        colspan="5"
                        class="text-right font-weight-black secondary--text"
                      >
                        TOTAL YANG HARUS DIBAYAR
                      </td>
                      <td>
                        <input
                          type="text"
                          :value="form.totalpayment"
                          class="form-text-combo text-right"
                          size="35"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <v-btn
                  depressed
                  small
                  color="primary"
                  @click="ReCalculate()"
                  v-if="form.totalpayment !== 0"
                  >HITUNG ULANG</v-btn
                >
              </div>
            </template>
          </v-tab-item>
          <v-tab-item value="tab-3">
            <v-card-title class="body-2 font-weight-bold">
              E-POLIS
            </v-card-title>
            <v-layout>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.branchclient_kanwildetail"
                    ref="kanwil"
                    label="Kanwil"
                    class="mx-2"
                    prepend-inner-icon="mdi-account-group"
                    @click="OpenData('kanwil')"
                    :readonly="
                      form.branchclient_login === '00003' ? false : true
                    "
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.branchclient_detail"
                    ref="outlet"
                    label="Outlet"
                    class="mx-2"
                    prepend-inner-icon="mdi-map-marker"
                    @click="OpenData('outlet')"
                    :readonly="
                      form.branchclient_login === '00003' ? false : true
                    "
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.contractno"
                    ref="contractno"
                    label="No Kontrak"
                    prepend-inner-icon="mdi-ticket-confirmation"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  v-if="form.branchclient_login === '00003'"
                >
                  <v-text-field
                    v-model="form.insured"
                    ref="insured"
                    class="mx-2"
                    label="Nama Peserta"
                    prepend-inner-icon="mdi-account-circle"
                  />
                </v-col>
              </v-row>
            </v-layout>
            <v-btn
              depressed
              small
              color="fourth"
              @click="CheckBatch()"
              v-if="form.branchclient_login !== '' || form.contractno !== ''"
              class="ml-2 mb-2"
              >CEK DATA</v-btn
            >
            <v-btn
              depressed
              small
              color="secondary"
              @click="ClearForm()"
              v-if="
                (form.branchclient_login !== '' || form.contractno !== '') &&
                  (form.branchclient_login === '00003' ||
                    login_user.substring(0, 9) === 'pgdkanwil')
              "
              class="ml-2 mb-2"
              >CLEAR FORM</v-btn
            >
          </v-tab-item>
          <v-tab-item value="tab-4">
            <v-row class="justify-center align-center">
              <v-col cols="12" class="my-5 ml-5" md="3">
                <template>
                  <v-card
                    elevation="5"
                    class="cursor hover-pending"
                    @click="GetData('pendingpegadaian')"
                  >
                    <v-card-title class="body-2 font-weight-bold"
                      >Pending Pegadaian <v-spacer></v-spacer
                      ><span
                        class="text-h3 font-weight-black"
                        v-text="pending_pegadaian"
                      ></span
                    ></v-card-title>
                  </v-card>
                </template>
              </v-col>
              <v-col cols="12" class="my-5 mx-0" md="3">
                <template>
                  <v-card
                    elevation="5"
                    class="cursor hover-pending"
                    @click="GetData('pendingtakaful')"
                  >
                    <v-card-title class="body-2 font-weight-bold"
                      >Pending Takaful <v-spacer></v-spacer
                      ><span
                        class="text-h3 font-weight-black"
                        v-text="pending_takaful"
                      ></span
                    ></v-card-title>
                  </v-card>
                </template>
              </v-col>
            </v-row>
            <v-tabs
              v-model="claimtab"
              icons-and-text
              dense
              background-color="secondary"
            >
              <v-tab href="#claimtab-1">
                REGISTER
                <v-icon>mdi-file-document-plus-outline</v-icon>
              </v-tab>
              <v-tab href="#claimtab-2">
                INQUIRY
                <v-icon>mdi-file-find</v-icon>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="claimtab">
              <v-tab-item value="claimtab-1">
                <v-layout>
                  <v-row class="mx-2 my-5">
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="claim.claim_id"
                        ref="claim_id"
                        label="ID *"
                        prepend-inner-icon="mdi-ticket-confirmation"
                        readonly
                        background-color="readonly"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="claim.claim_polno"
                        ref="claim_polno"
                        label="No Polis *"
                        prepend-inner-icon="mdi-ticket-account"
                        readonly
                        background-color="readonly"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-text-field
                        v-model="claim.claim_vehno"
                        ref="claim_desc"
                        label="Objek Info"
                        prepend-inner-icon="mdi-alert-decagram"
                        readonly
                        background-color="readonly"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="claim.claim_dol"
                        ref="claim_dol"
                        label="Tanggal Kejadian"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        background-color="readonly"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="claim.claim_reportdate"
                        ref="claim_reportdate"
                        label="Tanggal Laporan"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        background-color="readonly"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="claim.claim_desc"
                        ref="claim_desc"
                        label="Kronologi"
                        prepend-inner-icon="mdi-file-document"
                        readonly
                        background-color="readonly"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="claim.claim_status"
                        ref="claim_reportdate"
                        label="Status"
                        prepend-inner-icon="mdi-progress-question"
                        readonly
                        background-color="readonly"
                      />
                    </v-col>
                    <v-form
                      enctype="multipart/form-data"
                      ref="form_attachment"
                      lazy-validation
                      style="width: 100%;"
                    >
                      <v-col cols="12" sm="12" md="12">
                        <vue-dropzone
                          ref="myVueDropzone"
                          id="customdropzone"
                          v-on:vdropzone-file-added="AppendFile"
                          :options="dropzoneOptions"
                        ></vue-dropzone>
                      </v-col>
                    </v-form>
                    <v-col cols="12">
                      <v-btn color="primary" @click="Confirm(url_type, '')"
                        >UNGGAH LAMPIRAN</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-layout>
                <v-tabs
                  v-model="attachmenttab"
                  icons-and-text
                  dense
                  background-color="secondary"
                >
                  <v-tab href="#lampiran">
                    LAMPIRAN
                    <v-icon>mdi-attachment</v-icon>
                  </v-tab>
                  <v-tab href="#subrogasi">
                    SUBROGASI
                    <v-icon>mdi-cash-multiple</v-icon>
                  </v-tab>
                  <v-tabs-items v-model="attachmenttab">
                    <v-tab-item value="lampiran">
                      <v-data-table
                        :headers="headers_attach"
                        :items="list_attach"
                        :search="search.attachment"
                        @input="Check($event)"
                        item-key="policy_ano"
                        class="elevation-1"
                        :footer-props="{
                          showFirstLastPage: true,
                          firstIcon: 'mdi-page-first',
                          lastIcon: 'mdi-page-last',
                          prevIcon: 'mdi-chevron-left',
                          nextIcon: 'mdi-chevron-right'
                        }"
                        dense
                        :loading="loading.listattachment"
                        loading-text="Loading... Please wait"
                      >
                        <template v-slot:item.action="{ item }">
                          <a
                            :href="item.attachment_path_url"
                            target="_blank"
                            download
                          >
                            <v-icon
                              class="mr-2"
                              color="#00b0e4"
                              title="Download Dokumen"
                              >mdi-download-box</v-icon
                            >
                          </a>
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item value="subrogasi">
                      <v-data-table
                        :headers="headers_subro"
                        :items="list_subro"
                        :search="search.subro"
                        @input="Check($event)"
                        item-key="policy_ano"
                        class="elevation-1"
                        :footer-props="{
                          showFirstLastPage: true,
                          firstIcon: 'mdi-page-first',
                          lastIcon: 'mdi-page-last',
                          prevIcon: 'mdi-chevron-left',
                          nextIcon: 'mdi-chevron-right'
                        }"
                        dense
                        :loading="loading.listsubro"
                        loading-text="Loading... Please wait"
                      >
                      </v-data-table>
                    </v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-tab-item>
              <v-tab-item value="claimtab-2">
                <v-layout>
                  <v-row>
                    <v-col class="mx-auto" cols="12" md="6">
                      <v-text-field
                        v-model="claim.datavalue"
                        @keyup.enter="GetClaimData()"
                        class="mx-2"
                        ref="datavalue"
                        label="Cari Data Klaim"
                        append-icon="mdi-clipboard-text-search-outline"
                      />
                    </v-col>
                  </v-row>
                </v-layout>
                <div></div>
                <v-divider></v-divider>
                <v-progress-linear
                  indeterminate
                  color="primary"
                  v-if="loading.detail"
                ></v-progress-linear>
                <v-text-field
                  v-model="search.list"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  class="mx-2"
                ></v-text-field>
                <v-data-table
                  :headers="headers"
                  :items="list"
                  :search="claim.search"
                  @input="Check($event)"
                  item-key="policy_ano"
                  class="elevation-1"
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-page-first',
                    lastIcon: 'mdi-page-last',
                    prevIcon: 'mdi-chevron-left',
                    nextIcon: 'mdi-chevron-right'
                  }"
                  dense
                  :loading="loading.list"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:item.claim_clientproductid="{ item }">
                    {{ item.claim_clientproductid }} -
                    {{ item.claim_clientproductname }}
                  </template>
                  <template v-slot:item.claim_branchclientid="{ item }">
                    {{ item.claim_branchclientid }} -
                    {{ item.claim_branchclientname }}
                  </template>
                  <template v-slot:item.claim_dol="{ item }">
                    {{ $functions.FormatDateIndo(item.claim_dol) }}
                  </template>
                  <template v-slot:item.claim_reportdate="{ item }">
                    {{ $functions.FormatDateIndo(item.claim_reportdate) }}
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      class="mr-2"
                      color="#00b0e4"
                      @click="UploadDoc(item)"
                      title="Upload Dokumen"
                      >mdi-upload-box</v-icon
                    >
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
    <!-- Dialog Seacrh Policy -->
    <v-dialog v-model="select.policyno" hide-overlay fullscreen>
      <v-card>
        <v-layout>
          <v-flex xs12 sm12>
            <v-card flat>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="fourth" outlined @click="select.policyno = false">
                  Batal
                </v-btn>
              </v-card-actions>
              <v-text-field
                class="mx-2"
                v-model="search.policyno"
                placeholder="Cari No Polis dan Enter"
                id="filter_policyno"
                append-icon="mdi-magnify"
                @keyup.enter="OpenData('policyno')"
              ></v-text-field>
              <v-progress-linear
                indeterminate
                color="primary"
                v-if="loading.policyno"
              ></v-progress-linear>
              <v-list two-line class="pt-0">
                <span v-if="item.claim.length > 0">
                  <template v-for="(claim, $index) in item.claim">
                    <v-list-item
                      :key="claim.careclaim_certno"
                      :data-num="$index + 1"
                      ripple
                    >
                      <v-list-item-content
                        @click="
                          SetDataClaim(
                            'claim',
                            claim.careclaim_polno,
                            claim.careclaim_ano,
                            claim.careclaim_certno,
                            claim.careclaim_aname,
                            claim.careclaim_valuedesc5
                          )
                        "
                      >
                        <v-list-item-title
                          >{{ claim.careclaim_polno }}
                          <template v-if="claim.careclaim_certno">
                            <v-chip
                              class="ma-2 text-bold"
                              color="teal"
                              text-color="white"
                              small
                            >
                              <v-icon small left>
                                mdi-certificate
                              </v-icon>
                              {{ claim.careclaim_certno }}
                            </v-chip>
                          </template>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{
                          claim.careclaim_aname
                        }}</v-list-item-subtitle>
                        <v-spacer></v-spacer>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip
                          v-if="claim.careclaim_certno"
                          class="ma-2"
                          color="primary"
                          label
                          >{{ claim.careclaim_valuedesc5 }}</v-chip
                        >
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="$index + 1 < item.claim.length"
                      :key="$index"
                    ></v-divider>
                  </template>
                </span>
                <span v-else>
                  <template v-if="item.claim.length >= 0">
                    <v-list-item ripple>
                      <v-list-item-content>
                        <v-list-item-title>Tidak Ada Data</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action> </v-list-item-action>
                    </v-list-item>
                  </template>
                </span>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- Dialog Outlet Branch Client -->
    <v-dialog v-model="select.branchclient" hide-overlay fullscreen>
      <v-card>
        <v-layout>
          <v-flex xs12 sm12>
            <v-card flat>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="fourth"
                  outlined
                  @click="select.branchclient = false"
                >
                  Batal
                </v-btn>
              </v-card-actions>
              <v-text-field
                class="mx-2"
                v-model="search.branchclient"
                placeholder="Cari Outlet dan Enter"
                id="filter_branchclient"
                append-icon="mdi-magnify"
                @keyup.enter="OpenData('outlet')"
              ></v-text-field>
              <v-progress-linear
                indeterminate
                color="primary"
                v-if="loading.branchclient"
              ></v-progress-linear>
              <v-list two-line class="pt-0">
                <span v-if="item.branchclient.length > 0">
                  <template v-for="(branchclient, $index) in item.branchclient">
                    <v-list-item
                      :key="branchclient.branchclient_id"
                      :data-num="$index + 1"
                      ripple
                    >
                      <v-list-item-content
                        @click="
                          SetData(
                            'outlet',
                            branchclient.branchclient_id,
                            branchclient.branchclient_name
                          )
                        "
                      >
                        <v-list-item-title
                          >{{ branchclient.branchclient_id }} -
                          {{
                            branchclient.branchclient_name
                          }}</v-list-item-title
                        >
                      </v-list-item-content>
                      <v-list-item-action> </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="$index + 1 < item.branchclient.length"
                      :key="$index"
                    ></v-divider>
                  </template>
                </span>
                <span v-else>
                  <template v-if="item.branchclient.length >= 0">
                    <v-list-item ripple>
                      <v-list-item-content>
                        <v-list-item-title>Tidak Ada Data</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action> </v-list-item-action>
                    </v-list-item>
                  </template>
                </span>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End Dialog Branch Client -->
    <!-- Dialog Outlet Branch Client -->
    <v-dialog v-model="select.kanwil" hide-overlay fullscreen>
      <v-card>
        <v-layout>
          <v-flex xs12 sm12>
            <v-card flat>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="fourth" outlined @click="select.kanwil = false">
                  Batal
                </v-btn>
              </v-card-actions>
              <v-text-field
                class="mx-2"
                v-model="search.kanwil"
                placeholder="Cari Kanwil dan Enter"
                id="filter_kanwil"
                append-icon="mdi-magnify"
                @keyup.enter="OpenData('kanwil')"
              ></v-text-field>
              <v-progress-linear
                indeterminate
                color="primary"
                v-if="loading.kanwil"
              ></v-progress-linear>
              <v-list two-line class="pt-0">
                <span v-if="item.kanwil.length > 0">
                  <template v-for="(kanwil, $index) in item.kanwil">
                    <v-list-item
                      :key="kanwil.branchclient_kanwilid"
                      :data-num="$index + 1"
                      ripple
                    >
                      <v-list-item-content
                        @click="
                          SetData(
                            'kanwil',
                            kanwil.branchclient_kanwilid,
                            kanwil.branchclient_kanwil
                          )
                        "
                      >
                        <v-list-item-title
                          >{{ kanwil.branchclient_kanwilid }} -
                          {{ kanwil.branchclient_kanwil }}</v-list-item-title
                        >
                      </v-list-item-content>
                      <v-list-item-action> </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="$index + 1 < item.kanwil.length"
                      :key="$index"
                    ></v-divider>
                  </template>
                </span>
                <span v-else>
                  <template v-if="item.kanwil.length >= 0">
                    <v-list-item ripple>
                      <v-list-item-content>
                        <v-list-item-title>Tidak Ada Data</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action> </v-list-item-action>
                    </v-list-item>
                  </template>
                </span>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End Dialog Branch Kanwil -->
    <!-- Dialog Subjek -->
    <v-dialog v-model="select.batchsubject" width="820" persistent>
      <v-card>
        <v-layout>
          <v-flex xs12 sm12>
            <v-card flat>
              <v-card-actions class="primary white--text">
                {{ form.branchclient_id }} - {{ form.branchclient_name }}
                <v-spacer></v-spacer>
                <v-btn
                  color="fourth"
                  outlined
                  @click="select.batchsubject = false"
                >
                  Batal
                </v-btn>
              </v-card-actions>
              <!-- <v-text-field class="mx-2" v-model="search.branchclient" placeholder="Cari Outlet dan Enter" id="filter_branchclient" append-icon="mdi-magnify" @keyup.enter="OpenData('outlet')"></v-text-field> -->
              <v-progress-linear
                indeterminate
                color="primary"
                v-if="loading.batchsubject"
              ></v-progress-linear>
              <v-list two-line class="pt-0">
                <span v-if="item.batchsubject.length > 0">
                  <template v-for="(batchsubject, $index) in item.batchsubject">
                    <v-list-item
                      :key="batchsubject.subject_id"
                      :data-num="$index + 1"
                      ripple
                    >
                      <v-list-item-content>
                        <v-list-item-title>{{
                          batchsubject.subject_id
                        }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action v-if="form.numbers === $index">
                        Loading...
                      </v-list-item-action>
                      <v-list-item-action v-else>
                        <v-icon
                          large
                          @click="
                            PrintPDF(
                              $index,
                              batchsubject.subject_id,
                              batchsubject.branchclient_id
                            )
                          "
                          >mdi-file-pdf-box</v-icon
                        >
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="$index + 1 < item.batchsubject.length"
                      :key="$index"
                    ></v-divider>
                  </template>
                </span>
                <span v-else>
                  <v-list-item ripple>
                    <v-list-item-content>
                      <v-list-item-title>Tidak Ada Data</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action> </v-list-item-action>
                  </v-list-item>
                </span>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End Dialog Subjek -->
    <!-- Dialog Detail Insured -->
    <v-dialog v-model="select.insured" width="820" persistent>
      <v-card>
        <v-layout>
          <v-flex xs12 sm12>
            <v-card flat>
              <v-card-actions class="primary">
                <v-spacer></v-spacer>
                <v-btn color="fourth" outlined @click="select.insured = false">
                  Batal
                </v-btn>
              </v-card-actions>
              <!-- <v-text-field class="mx-2" v-model="search.branchclient" placeholder="Cari Outlet dan Enter" id="filter_branchclient" append-icon="mdi-magnify" @keyup.enter="OpenData('outlet')"></v-text-field> -->
              <v-progress-linear
                indeterminate
                color="primary"
                v-if="loading.insured"
              ></v-progress-linear>
              <v-list two-line class="pt-0">
                <span v-if="item.insured.length > 0">
                  <template v-for="(insured, $index) in item.insured">
                    <v-list-item
                      :key="insured.fastflow_row"
                      :data-num="$index + 1"
                      ripple
                    >
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ insured.fastflow_refid }} -
                          {{ insured.fastflow_insured }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          insured.fastflow_subject
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action v-if="form.numbers === $index">
                        Loading...
                      </v-list-item-action>
                      <v-list-item-action v-else>
                        <v-icon
                          large
                          @click="
                            PrintPDF(
                              $index,
                              insured.fastflow_subject,
                              insured.fastflow_branchclient
                            )
                          "
                          >mdi-file-pdf-box</v-icon
                        >
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="$index + 1 < item.insured.length"
                      :key="$index"
                    ></v-divider>
                  </template>
                </span>
                <span v-else>
                  <v-list-item ripple>
                    <v-list-item-content>
                      <v-list-item-title>Tidak Ada Data</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action> </v-list-item-action>
                  </v-list-item>
                </span>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- Dialog Claim Loss Location -->
    <v-dialog v-model="select.losslocation" hide-overlay fullscreen>
      <v-card>
        <v-layout>
          <v-flex xs12 sm12>
            <v-card flat>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="fourth"
                  outlined
                  @click="select.losslocation = false"
                >
                  Batal
                </v-btn>
                <v-btn
                  color="primary"
                  outlined
                  @click="select.losslocation = false"
                >
                  Ok
                </v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-textarea
                  outlined
                  v-model="claim.claim_losslocation"
                  name="claim_losslocation"
                  clearable
                  clear-icon="mdi-close-circle"
                  ref="claim_losslocation"
                  label="Lokasi Kejadian"
                  placeholder="Masukkan Lokasi Kejadian"
                ></v-textarea>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- Dialog Claim Loss Description -->
    <v-dialog v-model="select.lossdescription" hide-overlay fullscreen>
      <v-card>
        <v-layout>
          <v-flex xs12 sm12>
            <v-card flat>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="fourth"
                  outlined
                  @click="select.lossdescription = false"
                >
                  Batal
                </v-btn>
                <v-btn
                  color="primary"
                  outlined
                  @click="select.lossdescription = false"
                >
                  Ok
                </v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-textarea
                  outlined
                  v-model="claim.claim_lossdescription"
                  name="input-7-4"
                  clearable
                  clear-icon="mdi-close-circle"
                  label="Kronologi"
                  placeholder="Masukkan Kronologi Kejadian"
                ></v-textarea>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.confirm" width="500" persistent>
      <v-card>
        <v-card-title class="body-1 primary" style="color: white;">
          Proses?
        </v-card-title>
        <v-card-text class="body-2"> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="warning" text @click="dialog.confirm = false">
            Batal
          </v-btn>
          <v-btn
            class="primary"
            color="white"
            text
            :disabled="dialog_ok === 'Ok' ? false : true"
            @click="SubmitClaim()"
          >
            {{ dialog_ok }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="500"
      v-model="dialog.success"
    >
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="teal" dark>REGISTRASI BERHASIL</v-toolbar>
          <v-card-text>
            <div class="text-h3 pa-12">{{ claim.result }}</div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialog.value = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="500"
      v-model="dialog.error"
    >
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="red" dark>TERJADI KESALAHAN</v-toolbar>
          <v-card-text>
            <div class="text-h3 pa-12">{{ claim.result }}</div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialog.value = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog v-model="dialog.loading" hide-overlay persistent width="300">
      <v-card color="red" dark>
        <v-card-text>
          Loading...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.attachment" width="700" persistent>
      <v-card>
        <v-layout>
          <v-flex xs12 sm12>
            <v-card flat>
              <v-card-actions class="primary">
                <span style="color: white;">Attachment</span>
                <v-spacer></v-spacer>
                <v-btn
                  color="fourth"
                  outlined
                  @click="dialog.attachment = false"
                >
                  Batal
                </v-btn>
              </v-card-actions>
              <!-- <v-text-field class="mx-2" v-model="search.branchclient" placeholder="Cari Outlet dan Enter" id="filter_branchclient" append-icon="mdi-magnify" @keyup.enter="OpenData('outlet')"></v-text-field> -->
              <v-progress-linear
                indeterminate
                color="primary"
                v-if="loading.attachment"
              ></v-progress-linear>
              <v-list two-line class="pt-0">
                <span v-if="claim.attachment.length > 0">
                  <template v-for="(attachment, $index) in claim.attachment">
                    <v-list-item
                      :key="attachment.attachment_id"
                      :data-num="$index + 1"
                      ripple
                    >
                      <v-list-item-content>
                        <v-list-item-title>{{
                          attachment.attachment_path
                        }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <a
                          :href="attachment.attachment_path_url"
                          target="_blank"
                          download
                        >
                          <v-icon color="#00b0e4"
                            >mdi-download-box-outline</v-icon
                          >
                        </a>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="$index + 1 < claim.attachment.length"
                      :key="$index"
                    ></v-divider>
                  </template>
                </span>
                <span v-else>
                  <v-list-item ripple>
                    <v-list-item-content>
                      <v-list-item-title>Tidak Ada Data</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action> </v-list-item-action>
                  </v-list-item>
                </span>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirm.dialog"
      :max-width="Variable('confirm', 0)"
      persistent
    >
      <v-card :color="Variable('confirm', 4)">
        <v-card-title :class="Variable('confirm', 3)"
          >{{ confirm.title }}?</v-card-title
        >
        <v-card-text></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="dialog"
            :color="Variable('confirm', 1)"
            :disabled="confirm.text === 'Ok' ? false : true"
            @click="Loading"
          >
            {{ confirm.text }}
          </v-btn>
          <v-btn :color="Variable('confirm', 2)" @click="confirm.dialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.timeline" width="900" persistent>
      <v-card>
        <v-layout>
          <v-flex xs12 sm12>
            <v-card flat>
              <v-card-actions class="primary">
                <span style="color: white;">Timeline</span>
                <v-spacer></v-spacer>
                <v-btn color="fourth" outlined @click="dialog.timeline = false">
                  Batal
                </v-btn>
              </v-card-actions>
              <v-progress-linear
                indeterminate
                color="primary"
                v-if="loading.timeline"
              ></v-progress-linear>
              <template>
                <div class="overflow-y-auto" :style="{ maxHeight: '600px' }">
                  <v-timeline
                    class="mx-4"
                    align-top
                    :dense="$vuetify.breakpoint.smAndDown"
                  >
                    <v-timeline-item
                      v-for="(item, i) in list.attr"
                      :key="i"
                      :color="item.color"
                      :icon="item.icon"
                      fill-dot
                    >
                      <v-card :color="item.color" dark>
                        <v-card-title class="text-h6">
                          {{ item.title }}
                        </v-card-title>
                        <v-list-item
                          v-if="item.id == 'verify-claim'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              list.timeline.claim_cuser
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_cdate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'asign-surveyor'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{}}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_surveyassigndate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'claim-survey'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              list.timeline.claim_surveyby
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_surveydate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'assessor-estimate'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              list.timeline.claim_estassesorby
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_estassesordate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'claim-input'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              list.timeline.claim_inputby
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_inputdate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'claim-reserved'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              list.timeline.claim_reserveby
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_reservedate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'spk'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              list.timeline.claim_spkby
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_spkdate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'verify-document-send'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              list.timeline.claim_verdocby
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_verdocdate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'verify-document-accept'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              list.timeline.claim_verdocappby
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_verdocappdate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'publish-note'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              list.timeline.claim_publishnoteby
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_publishnotedate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'sign-note'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              list.timeline.claim_signnoteby
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_signnotedate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'disposition-note'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title>{{
                              list.timeline.claim_dispositionby
                            }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            {{
                              $functions.FormatDateTimeIndo(
                                list.timeline.claim_dispositiondate
                              )
                            }}
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-if="item.id == 'verify-bju'"
                          class="white text--primary"
                        >
                          <v-list-item-content>
                            <v-list-item-title></v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action> </v-list-item-action>
                        </v-list-item>
                      </v-card>
                    </v-timeline-item>
                  </v-timeline>
                </div>
              </template>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="select.platnomor">
      <v-list class="pt-0">
        <v-subheader class="primary white--text">Plat Nomor</v-subheader>
        <v-text-field
          v-model="search.platnomor"
          class="mx-2"
          prepend-inner-icon="mdi-magnify"
        />
        <div class="scrollable">
          <v-list-item
            v-for="row in filter_platnomor"
            :key="row.gendtab_id"
            @click="Choose('platnomor', row.gendtab_id, row.gendtab_desc)"
          >
            <v-list-item-title class="text-center">{{
              row.gendtab_id
            }}</v-list-item-title>
          </v-list-item>
        </div>
      </v-list>
    </v-bottom-sheet>
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.dialog"
      rounded="pill"
      bottom
    >
      {{ snackbar.text }}
      <template>
        <v-btn text @click.native="snackbar.dialog = false">Close</v-btn>
      </template>
    </v-snackbar>
  </base-section>
</template>
<script>
export default {
  name: "KalkulatorKontribusi",
  data: () => ({
    step: 1,
    expanded: [],
    expandedArea: [],
    currentExpandedId: null,
    currentExpandedAreaId: null,
    form: {
      tsi: 0,
      plat: "B",
      wilayah: "WILAYAH 2",
      year: 0,
      age: "0 Tahun",
      produk: "",
      tipe: "",
      depre: {},
      rate: {},
      coverage: {},
      detailtsi: {},
      contribution: {},
      loading: {},
      period: 0,
      number: 0,
      totalcontribution: 0,
      totalloading: 0,
      totalpayment: 0,
      calculate: false,
      branchclient_id: "",
      branchclient_name: "",
      branchclient_login: "",
      numbers: "",
      contractno: "",
      branchclient_kanwilid: "",
      branchclient_kanwilname: "",
      branchclient_kanwildetail: "",
      branchclient_detail: "",
      insured: "",
      filter: "PEMBIAYAAN"
    },
    pending_pegadaian: 0,
    pending_takaful: 0,
    claim: {
      claim_polno: "",
      claim_ano: "",
      claim_refid: "",
      claim_no: "",
      claim_id: "",
      claim_dol: "",
      claim_losslocation: "",
      claim_reportdate: "",
      claim_lossdescription: "",
      claim_vehno: "",
      claim_refno: "",
      claim_name: "",
      claim_phone: "",
      claim_phone_rule: [
        v => !!v || "Nomor HP harus diisi",
        v => /^\d+$/.test(v) || "Nomor HP tidak valid"
      ],
      claim_email: "",
      claim_email_rule: [
        v => !!v || "E-mail tidak boleh kosong",
        v => /.+@.+\..+/.test(v) || "Periksa kembali format email"
      ],
      claim_leaderid: "",
      claim_leadername: "",
      class_certno: "",
      claim_desc: "",
      claim_noc: "PARTIAL",
      uploads_sideleft: "",
      uploads_sideleft_url: "",
      uploads_sideright: "",
      uploads_sideright_url: "",
      uploads_sidefront: "",
      uploads_sidefront_url: "",
      uploads_sideback: "",
      uploads_sideback_url: "",
      datavalue: "",
      attachment: [],
      search: "",
      result: ""
    },
    list: [],
    listproduct: [],
    loading: {
      branchclient: false,
      batchsubject: false,
      print: false,
      kanwil: false,
      detail: false,
      list: false,
      timeline: false,
      attachment: false,
      policyno: false,
      listattachment: false,
      listsubro: false,
      area: false,
      outlet: false,
      product: false
    },
    format: {
      decimal: ",",
      thousands: ".",
      precision: 0
    },
    select: {
      platnomor: false,
      branchclient: false,
      batchsubject: false,
      kanwil: false,
      insured: false,
      policyno: false,
      losslocation: false,
      lossdescription: false,
      dateofloss: false,
      reportdate: false
    },
    dialog: {
      confirm: false,
      attachment: false,
      timeline: false,
      success: false,
      error: false,
      loading: false
    },
    dialog_ok: "Ok",
    item: {
      platnomor: [],
      produk: [
        { id: "CAR", desc: "TAKAFUL MOBIL" },
        { id: "MTR", desc: "TAKAFUL MOTOR" }
      ],
      tipe: [],
      tipecar: [
        { id: "CAR", desc: "MOBIL PENUMPANG" },
        { id: "TRUCK", desc: "TRUCK DAN PICK UP" },
        { id: "BUS", desc: "BUS" }
      ],
      tipemotor: [{ id: "MTR", desc: "SEPEDA MOTOR" }],
      coverage: [],
      coveragecar: ["TLO", "COMPRE"],
      coveragemotor: ["TLO"],
      branchclient: [],
      batchsubject: [],
      kanwil: [],
      insured: [],
      claim: [],
      policybykanwil: [],
      policybyarea: [],
      product: []
    },
    url_type: "add",
    search: {
      platnomor: "",
      branchclient: "",
      batchsubject: "",
      kanwil: "",
      policyno: "",
      list: "",
      attachment: "",
      subro: "",
      dashboard: "",
      product: ""
    },
    headers: [
      { text: "ID", value: "claim_id" },
      { text: "Kategori", value: "claim_category" },
      { text: "No Polis", value: "claim_refid" },
      { text: "Produk", value: "claim_clientproductid" },
      { text: "Objek Info", value: "claim_vehno" },
      { text: "Tanggal kejadian", value: "claim_dol" },
      { text: "Tanggal laporan", value: "claim_reportdate" },
      { text: "Kronologi", value: "claim_description" },
      { text: "Outlet", value: "claim_branchclientid" },
      { text: "Area", value: "claim_branchclientarea" },
      { text: "Kanwil", value: "claim_branchclientkanwil" },
      { text: "Status", value: "claim_statusdesc" },
      {
        text: "#",
        value: "action",
        sortable: false,
        align: "center",
        width: "1%"
      }
    ],
    list_attach: [],
    headers_attach: [
      { text: "Dokumen", value: "attachment_path" },
      { text: "Download", value: "action", sortable: false, align: "center" }
    ],
    //SnackBar
    snackbar: {
      dialog: false,
      color: "success",
      text: "",
      timeout: 3000
    },
    tab: null,
    claimtab: null,
    attachmenttab: null,
    login_user: "",
    formresponse: new FormData(),
    dropzoneOptions: {
      url: "/",
      thumbnailWidth: 200,
      autoProcessQueue: false,
      uploadMultiple: true,
      maxFiles: 10,
      addRemoveLinks: true,
      acceptedFiles: ".xls,.xlsx,.doc,.docx,.pdf,.jpeg,.jpg,.png,.eml",
      dictDefaultMessage: "UNGGAH LAMPIRAN KLAIM DISINI"
    },

    confirm: {
      dialog: false,
      title: "",
      text: "Ok"
    },
    list_subro: [],
    headers_kanwil: [
      { text: "ID", value: "id", width: "5%" },
      { text: "Kanwil", value: "description", width: "55%" },
      {
        text: "Total Kontribusi",
        value: "contribution",
        align: "end",
        width: "10%"
      },
      { text: "Total Klaim", value: "total_claim", align: "end", width: "10%" },
      {
        text: "Total Subro",
        value: "total_subrogation",
        align: "end",
        width: "10%"
      },
      {
        text: "Ratio Klaim (%)",
        value: "percentage",
        align: "end",
        width: "10%"
      }
    ],
    headers_area: [
      { text: "ID", value: "id", width: "5%" },
      { text: "Area", value: "description", width: "55%" },
      {
        text: "Total Kontribusi",
        value: "contribution",
        align: "end",
        width: "10%"
      },
      { text: "Total Klaim", value: "total_claim", align: "end", width: "10%" },
      {
        text: "Total Subro",
        value: "total_subrogation",
        align: "end",
        width: "10%"
      },
      {
        text: "Ratio Klaim (%)",
        value: "percentage",
        align: "end",
        width: "10%"
      }
    ],
    headers_outlet: [
      { text: "ID", value: "id", width: "5%" },
      { text: "Area", value: "description", width: "55%" },
      {
        text: "Total Kontribusi",
        value: "contribution",
        align: "end",
        width: "10%"
      },
      { text: "Total Klaim", value: "total_claim", align: "end", width: "10%" },
      {
        text: "Total Subro",
        value: "total_subrogation",
        align: "end",
        width: "10%"
      },
      {
        text: "Ratio Klaim (%)",
        value: "percentage",
        align: "end",
        width: "10%"
      }
    ],
    headers_product: [
      { text: "ID", value: "id", width: "5%" },
      { text: "Produk", value: "description", width: "55%" },
      {
        text: "Total Kontribusi",
        value: "contribution",
        align: "end",
        width: "10%"
      },
      { text: "Total Klaim", value: "total_claim", align: "end", width: "10%" },
      {
        text: "Total Subro",
        value: "total_subrogation",
        align: "end",
        width: "10%"
      },
      {
        text: "Ratio Klaim (%)",
        value: "percentage",
        align: "end",
        width: "10%"
      }
    ],
    headers_subro: [
      { text: "Keterangan", value: "claimsubro_description" },
      { text: "Tanggal Referensi", value: "claimsubro_refdate" },
      { text: "No Referensi", value: "claimsubro_refno" },
      { text: "Catatan", value: "claimsubro_remarks" },
      { text: "Mata Uang", value: "claimsubro_ccy" },
      { text: "Total", value: "claimsubro_amount" },
      { text: "Status", value: "claimsubro_status" }
    ],
    items: {
      filter: [
        { id: "PEMBIAYAAN" },
        { id: "KENDARAAN" },
        { id: "KEBAKARAN" },
        { id: "JIWA" }
      ]
    }
  }),
  provide: {
    heading: { align: "center" }
  },

  created() {
    this.FirstLoad();
    this.GetDashboardProduct();
    this.GetDashboardKanwil();
  },
  computed: {
    filter_platnomor() {
      const search_platnomor = this.search.platnomor.toLowerCase().trim();
      if (!search_platnomor) {
        return this.item.platnomor;
      } else {
        return this.item.platnomor.filter(
          b => b.gendtab_id.toLowerCase().indexOf(search_platnomor) > -1
        );
      }
    },
    totalContribution() {
      return this.item.product.reduce(
        (sum, item) => sum + item.contribution,
        0
      );
    },
    totalClaim() {
      return this.item.product.reduce((sum, item) => sum + item.total_claim, 0);
    },
    totalSubrogation() {
      return this.item.product.reduce(
        (sum, item) => sum + item.total_subrogation,
        0
      );
    }
  },
  methods: {
    FirstLoad() {
      let loginid = localStorage.getItem("website_users_id");
      if (loginid === null) {
        window.location.href = "/login";
      } else {
        this.login_user = loginid;
        this.form.year = this.$functions.Years();
        if (loginid === "pegadaian.pusat") {
          this.form.branchclient_login = "00003";
        } else {
          let otherid = localStorage.getItem("website_users_otherid");
          let othername = localStorage.getItem("website_users_othername");
          if (otherid !== "00003") {
            if (loginid.substring(0, 9) === "pgdkanwil") {
              this.form.branchclient_login = otherid;
              this.form.branchclient_kanwilid = otherid;
              this.form.branchclient_kanwilname = othername;
              this.form.branchclient_kanwildetail = otherid + " - " + othername;
            } else {
              this.form.branchclient_login = otherid;
              this.form.branchclient_id = otherid;
              this.form.branchclient_name = othername;
              this.form.branchclient_detail = otherid + " - " + othername;
            }
          }
        }
      }
    },
    Confirm(flag) {
      if (flag === "add" || flag === "edit") {
        if (this.$refs.form_attachment.validate()) {
          this.confirm.dialog = true;
          this.confirm.title = "Save?";
          this.url_type = "add";
          setTimeout(function() {
            document.getElementById("dialog").focus();
          }, 500);
        }
      }
    },
    GetData(flag) {
      if (flag === "platnomor") {
        this.search.platnomor = "";
        let formdata = new FormData();
        formdata.append("gendtab_refid", "V08");
        formdata.append("gendtab_actived", "Y");
        formdata.append("order_by", "gendtab_id");
        formdata.append("order_type", "ASC");
        this.$axios
          .post(this.$functions.SafeURL("apiListGenTableSimple"), formdata, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            this.select.platnomor = true;
            this.item.platnomor = response.data;
            this.ResetData();
          })
          .catch(e => {
            this.SnackBar(true, "error", e.message, 3000);
          });
      } else if (flag === "age") {
        let ages = this.$functions.Years() - this.form.year * 1;
        if (ages > 20) {
          alert("Usia kendaraan tidak boleh lebih dari 20 tahun");
          this.form.year = this.$functions.Years();
          this.form.suffix = "0 Tahun";
        } else {
          this.form.age = ages + " Tahun";
        }
        this.ResetData();
      } else if (flag === "produk") {
        this.form.tipe = [];
        if (this.form.produk.id === "CAR") {
          this.item.tipe = this.item.tipecar;
          this.item.coverage = this.item.coveragecar;
        } else if (this.form.produk.id === "MTR") {
          this.item.tipe = this.item.tipemotor;
          this.item.coverage = this.item.coveragemotor;
        }
        this.ResetData();
        this.form.calculate = false;
        this.form.period = 0;
      } else if (flag === "tipe") {
        this.ResetData();
      } else if (flag === "period") {
        if (this.form.period.length === 2) {
          this.ResetData();
          let checkperiod = this.form.period * 1;
          if (checkperiod % 12 === 0 || checkperiod === 18) {
            let period = checkperiod / 12;
            if (checkperiod === 18) {
              period = 2;
            }
            console.log(this.form.tsi);
            let tsivalue =
              this.$functions.ReplaceAllString(this.form.tsi, ".", "") * 1;
            if (period === 0) {
              alert("Mohon isi periode");
              this.form.period = 0;
              this.form.number = 0;
            } else if (period > 5) {
              alert("Periode tidak boleh lebih dari 5 tahun");
              this.form.period = 0;
              this.form.number = 0;
            } else if (
              this.form.tsi === 0 ||
              this.form.produk.id === undefined ||
              this.form.tipe.id === undefined
            ) {
              alert("Mohon isi harga, produk dan jenis kendaraan");
              this.form.period = 0;
              this.form.number = 0;
            } else {
              this.form.calculate = true;
              this.form.number = period;
              for (let i = 1; i <= period; i++) {
                let value = 100;
                if (i === 2) {
                  value = 90;
                } else if (i === 3) {
                  value = 80;
                } else if (i === 4) {
                  value = 70;
                } else if (i === 5) {
                  value = 60;
                }
                let tsinumber = (value * tsivalue) / 100;
                this.$set(this.form.depre, i, value);
                this.$set(this.form.detailtsi, i, tsinumber);
              }
            }
          } else {
            alert("Periode tidak masuk dalam coverage");
            this.form.period = 0;
            this.ResetData();
          }
        }
      } else if (flag === "pendingpegadaian") {
        this.claimtab = "claimtab-2";
        this.GetClaimData(flag);
      } else if (flag === "pendingtakaful") {
        this.claimtab = "claimtab-2";
        this.GetClaimData(flag);
      }
    },
    CalcTSI(period) {
      let tsivalue =
        this.$functions.ReplaceAllString(this.form.tsi, ".", "") * 1;
      for (let i = 1; i <= period; i++) {
        let depre = this.form.depre[i] * 1;
        this.$set(this.form.detailtsi, i, (depre / 100) * tsivalue);
      }
    },
    Coverage(number) {
      let coverage = this.form.coverage[number];
      let tsi = this.form.detailtsi[number];
      this.Calculate(number, coverage, tsi);
    },
    ResetData() {
      if (this.form.calculate === true) {
        let period = (this.form.period / 12) * 1;
        if (this.form.period === "18") {
          period = 2;
        }
        for (let i = 1; i <= period; i++) {
          this.$set(this.form.rate, i, 0);
          this.$set(this.form.contribution, i, 0);
          this.$set(this.form.loading, i, 0);
          this.$set(this.form.coverage, i, "");
        }
        this.form.totalcontribution = 0;
        this.form.totalloading = 0;
        this.form.totalpayment = 0;
      }
    },
    Calculate(number, coverage, tsi) {
      let formData = new FormData();
      formData.append("fastflowrate_category", "VEHICLE");
      formData.append("fastflowrate_id", this.form.tipe.id);
      formData.append("fastflowrate_type", "MAIN");
      formData.append("fastflowrate_tsi", tsi);
      formData.append("fastflowrate_region", this.form.plat);
      formData.append("fastflowrate_period", 1);
      formData.append("fastflowrate_periodunit", "Y");
      formData.append("fastflowrate_cover", coverage);
      this.$axios
        .post(this.$functions.SafeURL("apiListFastFlowRate", ``), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            let multiply = 1;
            if (this.form.period === "18" && number === 2) {
              multiply = 0.5;
            }
            let totalrate = response.data[0].fastflowrate_min * multiply;
            this.$set(this.form.rate, number, totalrate);
            let totalcontribution =
              response.data[0].fastflowrate_cont_min * multiply;
            this.$set(
              this.form.contribution,
              number,
              this.$functions.FormatNumber(totalcontribution, 0)
            );
            if (this.form.coverage[number] === "COMPRE") {
              let ages = this.$functions.Years() - this.form.year * 1 - 5;
              if (ages > 0) {
                let loading =
                  (ages *
                    0.05 *
                    response.data[0].fastflowrate_min *
                    multiply *
                    tsi) /
                  100;
                this.$set(
                  this.form.loading,
                  number,
                  this.$functions.FormatNumber(loading)
                );
              } else {
                this.$set(this.form.loading, number, 0);
              }
            } else {
              this.$set(this.form.loading, number, 0);
            }
            this.SumContribution();
          }
        })
        .catch(e => {
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    SumContribution() {
      let loading = 0;
      let total = 0;
      let period = this.form.period * 1;
      for (let i = 1; i <= period; i++) {
        if (this.form.contribution[i] !== undefined) {
          total +=
            this.$functions.ReplaceAllString(
              this.form.contribution[i],
              ".",
              ""
            ) * 1;
          if (
            this.form.loading[i] !== undefined &&
            this.form.loading[i] !== 0
          ) {
            loading +=
              this.$functions.ReplaceAllString(this.form.loading[i], ".", "") *
              1;
          }
        }
      }
      this.form.totalcontribution = this.$functions.FormatNumber(total);
      this.form.totalloading = this.$functions.FormatNumber(loading);
      this.form.totalpayment = this.$functions.FormatNumber(total + loading);
    },
    Choose(flag, id, desc) {
      switch (flag) {
        case "platnomor":
          this.form.plat = id;
          this.form.wilayah = desc;
          this.select.platnomor = false;
          break;
      }
    },
    ReCalculate() {
      this.ResetData();
      this.form.tsi = 0;
      this.$refs.tsi.$el.getElementsByTagName("input")[0].value = 0;
      this.form.plat = "B";
      this.form.wilayah = "WILAYAH 2";
      this.form.year = this.$functions.Years();
      this.form.age = "0 Tahun";
      this.form.produk = "";
      this.form.tipe = "";
      this.form.period = 0;
      this.form.calculate = false;
    },
    SnackBar(dialog, color, text, timeout) {
      this.snackbar.dialog = dialog;
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.timeout = timeout;
    },
    OpenData(data) {
      if (
        data === "outlet" &&
        (this.form.branchclient_login === "00003" ||
          this.login_user.substring(0, 9) === "pgdkanwil")
      ) {
        this.item.branchclient = [];
        this.select.branchclient = true;
        setTimeout(function() {
          document.getElementById("filter_branchclient").focus();
        }, 500);
        if (
          this.search.branchclient !== "" ||
          this.form.branchclient_kanwilid !== ""
        ) {
          this.loading.branchclient = true;
          let formData = new FormData();
          formData.append("datavalue", this.search.branchclient);
          formData.append(
            "branchclient_kanwilid",
            this.form.branchclient_kanwilid
          );
          formData.append("branchclient_group", "PEGADAIAN");
          formData.append("order_by", "branchclient_id");
          formData.append("order_type", "ASC");
          this.$axios
            .post(
              this.$functions.SafeURL("apiListBranchClient", ``),
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }
            )
            .then(response => {
              let feedback = response.data;
              if (feedback.length > 0) {
                this.item.branchclient = feedback;
              }
              this.loading.branchclient = false;
            })
            .catch(e => {
              this.loading.branchclient = false;
              this.SnackBar(true, "error", e.message, 3000);
            });
        }
      } else if (
        data === "kanwil" &&
        this.form.branchclient_login === "00003"
      ) {
        this.item.kanwil = [];
        this.select.kanwil = true;
        setTimeout(function() {
          document.getElementById("filter_kanwil").focus();
        }, 500);
        if (this.search.kanwil !== "") {
          this.loading.kanwil = true;
          let formData = new FormData();
          formData.append("datavalue", this.search.kanwil);
          formData.append("order_by", "branchclient_mergeid");
          formData.append("order_type", "ASC");
          this.$axios
            .post(
              this.$functions.SafeURL("apiListBranchClientKanwil", ``),
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }
            )
            .then(response => {
              let feedback = response.data;
              if (feedback.length > 0) {
                this.item.kanwil = feedback;
              }
              this.loading.kanwil = false;
            })
            .catch(e => {
              this.loading.kanwil = false;
              this.SnackBar(true, "error", e.message, 3000);
            });
        }
      } else if (
        data === "policyno" &&
        this.form.branchclient_login === "00003"
      ) {
        this.item.policyno = [];
        this.select.policyno = true;
        setTimeout(function() {
          document.getElementById("filter_policyno").focus();
        }, 500);
        if (this.search.policyno !== "") {
          this.loading.policyno = true;
          let formData = new FormData();
          formData.append("careclaim_vehicle", this.search.policyno);
          formData.append("order_by", "a.POLICYNO,a.ADATE,a.ASTATUS");
          formData.append("order_type", "DESC");
          this.$axios
            .post(
              this.$functions.SafeURL("apiListCareSearchPolicy", ``),
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }
            )
            .then(response => {
              let feedback = response.data;
              if (feedback.length > 0) {
                this.item.claim = feedback;
              }
              this.loading.policyno = false;
            })
            .catch(e => {
              this.loading.policyno = false;
              this.SnackBar(true, "error", e.message, 3000);
            });
        }
      } else if (
        data === "lossloc" &&
        this.form.branchclient_login === "00003"
      ) {
        this.select.losslocation = true;
        this.$refs.claim_losslocation.focus();
      } else if (
        data === "lossdesc" &&
        this.form.branchclient_login === "00003"
      ) {
        this.select.lossdescription = true;
      }
    },
    SetData(flag, id, desc) {
      if (flag === "outlet") {
        this.form.branchclient_id = id;
        this.form.branchclient_name = desc;
        this.form.branchclient_detail = id + " - " + desc;
        this.select.branchclient = false;
        this.CheckBatch();
      } else if (flag === "kanwil") {
        this.form.branchclient_kanwilid = id;
        this.form.branchclient_kanwilname = desc;
        this.form.branchclient_kanwildetail = id + " - " + desc;
        this.select.kanwil = false;
        this.OpenData("outlet");
      }
    },
    SetDataClaim(
      flag,
      policyno,
      claim_ano,
      claim_certno,
      claim_name,
      claim_vehno
    ) {
      if (flag === "claim") {
        this.claim.claim_polno = policyno;
        this.claim.claim_ano = claim_ano;
        this.claim.claim_certno = claim_certno;
        this.claim.claim_desc = policyno + " [" + claim_certno + "]";
        this.claim.claim_name = claim_name;
        this.claim.claim_vehno = claim_vehno;
        this.select.policyno = false;
      }
    },
    CheckBatch() {
      if (this.form.insured !== "") {
        this.select.insured = true;
        this.loading.insured = true;
        let formData = new FormData();
        formData.append("fastflow_insured", this.form.insured);
        formData.append("fastflow_inquiry", "PEGADAIAN");
        formData.append("fastflow_group", "PEGADAIAN");
        this.$axios
          .post(this.$functions.SafeURL("apiListFastFlow", ``), formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            let feedback = response.data;
            if (feedback.length > 0) {
              if (feedback[0].feedback === "Y") {
                this.item.insured = feedback;
              } else {
                this.SnackBar(true, "error", feedback[0].feedback, 0);
              }
            } else {
              this.item.insured = feedback;
            }
            this.loading.insured = false;
          })
          .catch(e => {
            this.loading.insured = false;
            this.SnackBar(true, "error", e.message, 3000);
          });
      } else {
        this.select.batchsubject = true;
        this.loading.batchsubject = true;
        let formData = new FormData();
        formData.append("fastflow_refid", this.form.contractno);
        formData.append("fastflow_branchclient", this.form.branchclient_id);
        formData.append(
          "fastflow_branchkanwil",
          this.form.branchclient_kanwilid
        );
        formData.append("fastflow_group", "PEGADAIAN");
        this.$axios
          .post(
            this.$functions.SafeURL("apiListFastflowSubject", ``),
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          )
          .then(response => {
            let feedback = response.data;
            if (feedback.length > 0) {
              if (feedback[0].feedback === "Y") {
                this.form.branchclient_id = feedback[0].branchclient_id;
                this.form.branchclient_name = feedback[0].branchclient_name;
                this.form.branchclient_detail =
                  feedback[0].branchclient_id +
                  " - " +
                  feedback[0].branchclient_name;
                this.item.batchsubject = feedback;
              } else {
                this.SnackBar(true, "error", feedback[0].feedback, 0);
              }
            } else {
              this.item.batchsubject = feedback;
            }
            this.loading.batchsubject = false;
          })
          .catch(e => {
            this.loading.batchsubject = false;
            this.SnackBar(true, "error", e.message, 3000);
          });
      }
    },
    PrintPDF(index, id, branchclient) {
      this.form.numbers = index;
      let formData = new FormData();
      formData.append("fastflow_branchclient", branchclient);
      formData.append("fastflow_branchkanwil", this.form.branchclient_kanwil);
      formData.append("fastflow_subject", id);
      this.$axios
        .post(
          this.$functions.SafeURL("apiListFastflowPrintSubject", ``),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              window.open(feedback[0].subject_url, "_blank");
            } else {
              this.SnackBar(true, "error", feedback[0].feedback, 3000);
            }
          } else {
            this.SnackBar(true, "error", "No Data Found", 3000);
          }
          this.form.numbers = "";
        })
        .catch(e => {
          this.form.numbers = "";
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    ClearForm() {
      this.form.branchclient_id = "";
      this.form.branchclient_name = "";
      this.form.branchclient_detail = "";
      if (this.form.branchclient_login === "00003") {
        this.form.branchclient_kanwilid = "";
        this.form.branchclient_kanwilname = "";
        this.form.branchclient_kanwildetail = "";
      }
      this.form.contractno = "";
      this.form.insured = "";
    },
    UploadAttachmentClick(position) {
      if (position === "left") {
        this.$refs.setting_uploads_sideleft.click();
      } else if (position === "right") {
        this.$refs.setting_uploads_sideright.click();
      } else if (position === "front") {
        this.$refs.setting_uploads_sidefront.click();
      } else if (position === "back") {
        this.$refs.setting_uploads_sideback.click();
      }
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    UploadAttachment(position) {
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        // Define a callback function to run when FileReader finishes its job
        reader.onload = e => {
          // Set the appropriate attachment URL based on the position
          switch (position) {
            case "left":
              this.claim.uploads_sideleft_url = e.target.result;
              this.claim.uploads_sideleft = input.files[0];
              break;
            case "right":
              this.claim.uploads_sideright_url = e.target.result;
              this.claim.uploads_sideright = input.files[0];
              break;
            case "front":
              this.claim.uploads_sidefront_url = e.target.result;
              this.claim.uploads_sidefront = input.files[0];
              break;
            case "back":
              this.claim.uploads_sideback_url = e.target.result;
              this.claim.uploads_sideback = input.files[0];
              break;
            default:
              break;
          }
        };
        // Start the reader job - read file as a data URL (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    SubmitClaim() {
      this.dialog_ok = "Loading...";
      this.dialog.loading = true;
      let formData = new FormData();
      formData.append("url_type", "add");
      formData.append("claim_rule", "client");
      formData.append("claim_ano", this.claim.claim_ano);
      formData.append("claim_polno", this.claim.claim_polno);
      formData.append("claim_dol", this.claim.claim_dol);
      formData.append("claim_reportdate", this.claim.claim_reportdate);
      formData.append("claim_vehno", this.claim.claim_vehno);
      formData.append("claim_noc", this.claim.claim_noc);
      formData.append("claim_location", this.claim.claim_losslocation);
      formData.append("claim_description", this.claim.claim_lossdescription);
      formData.append("claim_name", this.claim.claim_name);
      formData.append("claim_phone", this.claim.claim_phone);
      formData.append("claim_upload", "Y");
      formData.append("uploads_sideleft", this.claim.uploads_sideleft);
      formData.append("uploads_sideright", this.claim.uploads_sideright);
      formData.append("uploads_sideback", this.claim.uploads_sideback);
      formData.append("uploads_sidefront", this.claim.uploads_sidefront);
      // console.log(formData);return false;
      this.$axios
        .post(this.$functions.SafeURL("apiWriteClaim", ``), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          let feedback = response.data;
          this.dialog.confirm = false;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              // this.dialog.success = true
              this.claimtab = "claimtab-2";
              this.claim.datavalue = feedback[0].claim_id;
              this.GetClaimData();
              this.SnackBar(true, "success", feedback[0].claim_id, 3000);
              this.$refs.form1.reset();
              this.$refs.form2.reset();
              this.$refs.form1.resetValidation();
              this.$refs.form2.resetValidation();
              this.claim.uploads_sideleft_url = "";
              this.claim.uploads_sideright_url = "";
              this.claim.uploads_sideback_url = "";
              this.claim.uploads_sidefront_url = "";
            } else {
              this.dialog.error = true;
              this.claim.result = feedback[0].feedback;
            }
            this.dialog.loading = false;
          } else {
            this.SnackBar(true, "error", "No Data Found", 3000);
          }
          this.dialog_ok = "Ok";
        })
        .catch(e => {
          this.dialog_ok = "Ok";
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    GetClaimDashboard() {
      this.loading.policyno = true;
      let formData = new FormData();
      this.$axios
        .post(
          this.$functions.SafeURL("apiPegadaianProductTotal", ``),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              this.listproduct = feedback;
            } else {
              this.listproduct = "";
              this.SnackBar(true, "error", feedback[0].feedback, 0);
            }
            this.loading.policyno = false;
          } else {
            this.list = feedback;
          }
          this.loading.batchsubject = false;
        })
        .catch(e => {
          this.loading.batchsubject = false;
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    GetTotalClaim() {
      let formData = new FormData();
      formData.append("websitef", "Y");
      this.$axios
        .post(this.$functions.SafeURL("apiPegadaianClaimTotal", ``), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              this.pending_pegadaian = feedback
                .filter(
                  claim =>
                    claim.feedback === "Y" &&
                    (claim.claim_status === "M" || claim.claim_status === "N")
                )
                .reduce((total, claim) => total + claim.claim_count, 0);

              // Calculate pending_takaful where claim_status is "I"
              this.pending_takaful = feedback
                .filter(
                  claim => claim.feedback === "Y" && claim.claim_status === "I"
                )
                .reduce((total, claim) => total + claim.claim_count, 0);
            } else {
              this.pending_pegadaian = 0;
              this.pending_takaful = 0;
            }
            this.loading.list = false;
          } else {
            this.list = feedback;
          }
          this.loading.list = false;
        })
        .catch(e => {
          this.loading.list = false;
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    GetClaimData(flag) {
      this.loading.list = true;
      let formData = new FormData();
      formData.append("datavalue", this.claim.datavalue);
      if (flag == "pendingpegadaian") {
        formData.append("claim_pendingpegadaianf", "Y");
      } else if (flag == "pendingtakaful") {
        formData.append("claim_pendingtakafulf", "Y");
      }
      // formData.append("limit", 10);
      this.$axios
        .post(this.$functions.SafeURL("apiListClaimPegadaian", ``), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              this.list = feedback;
            } else {
              this.list = "";
              this.SnackBar(true, "error", feedback[0].feedback, 0);
            }
            this.loading.list = false;
          } else {
            this.list = feedback;
          }
          this.loading.list = false;
        })
        .catch(e => {
          this.loading.list = false;
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    UploadDoc(item) {
      this.claimtab = "claimtab-1";
      this.claim.claim_id = item.claim_id;
      this.claim.claim_polno = item.claim_polno;
      this.claim.claim_vehno = item.claim_vehno;
      this.claim.claim_dol = item.claim_dol;
      this.claim.claim_reportdate = item.claim_reportdate;
      this.claim.claim_desc = item.claim_description;
      this.claim.claim_status = item.claim_statusdesc;
      this.ListAttachment(item.claim_id);
    },
    ValidateStep1() {
      if (this.$refs.form1.validate()) {
        this.step = 2;
      }
    },
    ValidateStep2() {
      if (this.$refs.form2.validate()) {
        if (this.claim.uploads_sideleft == "") {
          this.SnackBar(true, "error", "Upload Foto Samping Kiri", 3000);
        } else if (this.claim.uploads_sideright == "") {
          this.SnackBar(true, "error", "Upload Foto Samping Kanan", 3000);
        } else if (this.claim.uploads_sidefront == "") {
          this.SnackBar(true, "error", "Upload Foto Bagian Depan", 3000);
        } else if (this.claim.uploads_sideback == "") {
          this.SnackBar(true, "error", "Upload Foto Bagian Bekalang", 3000);
        } else {
          this.dialog.confirm = true;
        }
      }
    },
    CheckTimeline(item) {
      this.list.timeline = item;
      this.list.attr = [
        {
          title: "Report and Verification Claim",
          color: item.claim_cuser !== "" ? "green darken-2" : "red darken-2",
          icon:
            item.claim_cuser !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "verify-claim"
        },
        {
          title: "Assign Surveyor",
          color:
            item.claim_surveyassignby !== ""
              ? "green darken-2"
              : "red darken-2",
          icon:
            item.claim_surveyassignby !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "asign-surveyor"
        },
        {
          title: "Claim Survey",
          color: item.claim_surveyby !== "" ? "green darken-2" : "red darken-2",
          icon:
            item.claim_surveyby !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "claim-survey"
        },
        {
          title: "Assessor Estimate",
          color:
            item.claim_estassesorby !== "" ? "green darken-2" : "red darken-2",
          icon:
            item.claim_estassesorby !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "assessor-estimate"
        },
        {
          title: "Claim Input",
          color: item.claim_inputby !== "" ? "green darken-2" : "red darken-2",
          icon:
            item.claim_inputby !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "claim-input"
        },
        {
          title: "Claim Reserved",
          color:
            item.claim_reserveby !== "" ? "green darken-2" : "red darken-2",
          icon:
            item.claim_reserveby !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "claim-reserved"
        },
        {
          title: "SPK",
          color: item.claim_spkby !== "" ? "green darken-2" : "red darken-2",
          icon:
            item.claim_spkby !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "spk"
        },
        {
          title: "Verification Document (Send)",
          color: item.claim_verdocby !== "" ? "green darken-2" : "red darken-2",
          icon:
            item.claim_verdocby !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "verify-document-send"
        },
        {
          title: "Verification Document (Accept)",
          color:
            item.claim_verdocappby !== "" ? "green darken-2" : "red darken-2",
          icon:
            item.claim_verdocappby !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "verify-document-accept"
        },
        {
          title: "Publish Note",
          color:
            item.claim_publishnoteby !== "" ? "green darken-2" : "red darken-2",
          icon:
            item.claim_publishnoteby !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "publish-note"
        },
        {
          title: "Sign Note",
          color:
            item.claim_signnoteby !== "" ? "green darken-2" : "red darken-2",
          icon:
            item.claim_signnoteby !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "sign-note"
        },
        {
          title: "Disposition Note",
          color:
            item.claim_dispositionby !== "" ? "green darken-2" : "red darken-2",
          icon:
            item.claim_dispositionby !== ""
              ? "mdi-check-decagram"
              : "mdi-progress-close",
          id: "disposition-note"
        }
      ];
      this.dialog.timeline = true;
    },
    Variable(flag, position) {
      return this.$functions.Variable(flag, position);
    },
    AppendFile(file) {
      this.formresponse.append("file", file);
    },
    Loading() {
      this.confirm.text = "Loading...";
      if (this.url_type === "add" || this.url_type === "edit") {
        this.Write();
      } else if (this.url_type === "delete") {
        this.Delete(this.form.attachment_id);
      } else if (this.url_type === "multidelete") {
        this.MultiProcess("delete");
      }
    },
    Write() {
      this.formresponse.append("url_type", "add");
      this.formresponse.append("attachment_refno", this.claim.claim_id);
      this.$axios
        .post(
          this.$functions.SafeURL("apiWriteAttachmentPegadaian", ``),
          this.formresponse,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          let feedback = response.data;
          if (feedback[0].feedback === "Y") {
            let feed;
            if (feedback[0].feedback_failed == 0) {
              feed = `Success : ${feedback[0].feedback_success}, Failed : ${feedback[0].feedback_failed}`;
            } else {
              this.remarks.feedback = feedback[0].feedback_failed_remarks;
              feed = `Success : ${feedback[0].feedback_success}, Failed : ${feedback[0].feedback_failed}`;
              this.remarks.dialog = true;
            }
            this.$refs.myVueDropzone.removeAllFiles();
            this.SnackBar(true, "success", feed, 0);
            this.confirm.dialog = false;
            this.confirm.text = "Ok";
            this.dialog.detail = false;
            this.selected = [];
            this.ListAttachment(this.claim.claim_id);
          } else {
            this.SnackBar(true, "error", this.$functions.ErrorCode(), 0);
            this.remarks.dialog = true;
            this.remarks.feedback = feedback[0].feedback;
          }
        })
        .catch(e => {
          this.SnackBar(true, "error", e, 0);
          this.dialog.response = false;
          this.confirm.text = "Ok";
        });
    },
    ListAttachment(id) {
      let formData = new FormData();
      formData.append("attachment_modul", "claimpgdattach");
      formData.append("attachment_refno", id);
      formData.append("limit", 10);
      this.$axios
        .post(this.$functions.SafeURL("apiListAttachment", ``), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              this.list_attach = feedback;
            } else {
              this.list = "";
              this.SnackBar(true, "error", feedback[0].feedback, 0);
            }
            this.loading.listattachment = false;
          } else {
            this.list_attach = feedback;
          }
          this.loading.listattachment = false;
        })
        .catch(e => {
          this.loading.listattachment = false;
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    GetDashboardProduct() {
      let formData = new FormData();
      formData.append("url_type", "product");
      formData.append("branchclient_category", this.form.filter);
      this.loading.product = true;
      this.$axios
        .post(
          this.$functions.SafeURL("apiListDashboardPegadaian", ``),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              this.item.product = feedback;
            } else {
              this.SnackBar(true, "error", feedback[0].feedback, 0);
            }
          } else {
            this.item.product = feedback;
          }
          this.loading.product = false;
        })
        .catch(e => {
          this.loading.product = false;
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    GetDashboardKanwil() {
      let formData = new FormData();
      formData.append("url_type", "kanwil");
      formData.append("branchclient_category", this.form.filter);
      this.loading.kanwil = true;
      this.$axios
        .post(
          this.$functions.SafeURL("apiListDashboardPegadaian", ``),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              this.item.policybykanwil = feedback;
            } else {
              this.SnackBar(true, "error", feedback[0].feedback, 0);
            }
          } else {
            this.item.policybykanwil = feedback;
          }
          this.loading.kanwil = false;
        })
        .catch(e => {
          this.loading.kanwil = false;
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    GetDashboardArea(id) {
      let formData = new FormData();
      formData.append("url_type", "area");
      formData.append("branchclient_kanwilid", id);
      formData.append("branchclient_category", this.form.filter);
      this.loading.area = true;
      this.$axios
        .post(
          this.$functions.SafeURL("apiListDashboardPegadaian", ``),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              this.item.policybyarea = feedback;
            } else {
              this.SnackBar(true, "error", feedback[0].feedback, 0);
            }
          } else {
            this.item.policybyarea = feedback;
          }
          this.loading.area = false;
        })
        .catch(e => {
          this.loading.area = false;
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    GetDashboardOutlet(id) {
      let formData = new FormData();
      formData.append("url_type", "outlet");
      formData.append("branchclient_areaid", id);
      formData.append("branchclient_category", this.form.filter);
      this.loading.outlet = true;
      this.$axios
        .post(
          this.$functions.SafeURL("apiListDashboardPegadaian", ``),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          let feedback = response.data;
          if (feedback.length > 0) {
            if (feedback[0].feedback === "Y") {
              this.item.policybyoutlet = feedback;
            } else {
              this.SnackBar(true, "error", feedback[0].feedback, 0);
            }
          } else {
            this.item.policybyoutlet = feedback;
          }
          this.loading.outlet = false;
        })
        .catch(e => {
          this.loading.outlet = false;
          this.SnackBar(true, "error", e.message, 3000);
        });
    },
    HandleRowClick(item) {
      if (this.currentExpandedId === item.id) {
        this.currentExpandedId = null;
      } else {
        this.currentExpandedId = item.id;
        this.item.policybyarea = [];
        this.GetDashboardArea(item.id);
      }
    },
    isExpanded(id) {
      return this.currentExpandedId === id;
    },
    HandleAreaRowClick(item) {
      if (this.currentExpandedAreaId === item.id) {
        this.currentExpandedAreaId = null;
        this.item.policybyoutlet = [];
      } else {
        this.currentExpandedAreaId = item.id;
        this.item.policybyoutlet = [];
        this.GetDashboardOutlet(item.id);
      }
    },
    isAreaExpanded(id) {
      return this.currentExpandedAreaId === id;
    },
    CalculatePercentage(claim, contribution, subro) {
      let totalcontribution = contribution;
      if (this.form.filter === "PEMBIAYAAN") {
        totalcontribution = contribution * 0.75;
      }
      if (!contribution || contribution === 0) return "0.00";
      return (((claim - subro) / totalcontribution) * 100).toFixed(2);
    },
    FilterData(id) {
      this.form.filter = id;
      this.GetDashboardProduct();
      this.GetDashboardKanwil();
    }
  }
};
</script>
<style scoped>
.hover-pending:hover {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  transform: scale(1.03);
  box-shadow: 1px 3px 4px rgb(255 136 0) !important;
}
.vue-dropzone {
  border: 2px solid #008493;
  color: #008493;
  border-radius: 15px;
  font-size: 30px;
  font-weight: bold;
}
.v-tab--active {
  background: #ff8800 !important;
}
::v-deep .expanded-row-area td {
  background-color: #ff8800 !important;
  color: #ffffff !important;
  font-weight: bold !important;
}
::v-deep .custom-bg-area {
  padding: 0px 2px 2px 2px !important;
  background-color: #ff8800 !important;
}
::v-deep .expanded-row-area:hover td {
  background-color: #ff8800 !important;
}
::v-deep .expanded-row-area td span {
  color: #ffffff !important;
}
::v-deep .expanded-row td {
  background-color: #001f48 !important;
  color: #ffffff !important;
  font-weight: bold !important;
}
::v-deep .custom-bg {
  background-color: #001f48 !important;
  padding: 0px 2px 2px 2px !important;
}
/* Override hover state */
::v-deep .expanded-row:hover td {
  background-color: #001f48 !important;
}
::v-deep .expanded-row td span {
  color: #ffffff !important;
}
.text-detail {
  color: #001f48;
  padding: 5px 10px;
}
.text-detail-outlet {
  color: #ff8800;
  padding: 5px 10px;
}
.v-data-table tbody tr {
  cursor: pointer;
}
</style>
